<template>
  <div class="filter__toggle LKRoadmapsFeedFilterToggle">
    <div class="text-md mod--filter">
      {{ title }}
    </div>

    <div class="text-md-bold mod--filter">
      {{ desc }}
    </div>

    <img
      src="/images/arrow.svg"
      loading="lazy"
      alt=""
      class="filter__toggle__icon LKRoadmapsFeedFilterToggle__icon"
      :class="{ 'filter__toggle__icon_active': active }"
    >
  </div>
</template>

<script>
export default {
  name: 'LKRoadmapsFeedFilterToggle',
  props: {
    active: Boolean,
    title: {
      type: String,
      required: true,
    },
    desc: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.LKRoadmapsFeedFilterToggle {
  &__icon {
    margin-left: auto;
  }
}
</style>
